<template>
    <b-container class="container">
        <b-row>
            <b-col cols="12" lg="4">
                <h3><font-awesome-icon icon="info-circle" /> Was?</h3>
                <p>Unser {{ weinprobenCounter }}. <i>"Zenhnteles-Schlotzer-Spaziergang"</i> findet auch {{ year }} wieder in den Grunbachern Weinbergen statt.</p>
                <p>Erneut bieten wir eine idyllische Weinprobe verteilt auf vier Ständen. Versuchen Sie unsere feinen Weine aus Remshaldener und Schorndorfer Lagen: Chardonnay, Grauer Bugunder, Spätburgunder, Riesling, Trollinger, Kerner und vieles mehr. Wir freuen uns auf Ihr Kommen!</p>
            </b-col>
            <b-col cols="12" lg="4">
                <h3><font-awesome-icon icon="calendar-alt" /> Wann?</h3>
                <p>Samstag, {{ daySaturday }}.08.{{ year }} ab 16 Uhr</p>
                <p>Sonntag, {{ daySunday }}.08.{{ year }} ab 11 Uhr</p>
            </b-col>
            <b-col cols="12" lg="4">
                <h3><font-awesome-icon icon="map-marked-alt" /> Wo?</h3>
                <p>In den idyllischen Grunbachern Weinbergen.</p>
                <b-button variant="success" to="Anfahrt">Zur Anfahrt...</b-button>
            </b-col>
        </b-row>
        <b-row v-if="isFullSite">
            <b-col style="margin-top: 1em">
                <a :href="require('../assets/Weinprobe_Weinberge.pdf')" download="Flyer_Weinprobe_Grunbach.pdf">
                    <b-img center src="../assets/images/flyer.png" fluid alt="Flyer der Weinprobe in den Weinbergen"></b-img>
                </a>                
            </b-col>
        </b-row>
        <b-row class="highlights">
           <b-col>
                <b-card no-body class="overflow-hidden mb-3">
                    <b-row no-gutters>
                        <b-col md="4">
                            <b-card-img src="../assets/images/highlight.jpg" class="rounded-0"></b-card-img>
                        </b-col>
                        <b-col md="8">
                            <b-card-body>
                                <b-card-text>
                                    <h3><font-awesome-icon icon="check-double" /> Highlights</h3>
                                    <ul>
                                        <li>30+ Wein- und Sektsorten</li>
                                        <li>4 Stände</li>
                                        <li>Samstags Salzkuchen</li>
                                        <li>Gottesdienst im Grünen am Sonntag</li>
                                    </ul>
                                </b-card-text>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
           </b-col>
        </b-row>
        <b-row v-if="isFullSite">
            <b-col>
                <h2>Stände</h2>
                <p>Alle Stände bieten neben einer vielzahl von Weinen auch eine Auswahl von alkoholfreien Getränken und Vesper. Zusätzlich hat jeder Stand seine eigene Spezialitäten, die es zu entdecken gibt.</p>
                <p>Jeder Stand hat unterschiedliche Weine. Es lohnt sich somit jedem Stand einen Besuch abzustatten! Verwenden Sie die <b-link to="Karte" class="card-link">Übersichtskarte</b-link> um die Stände zu finden.</p>
                <p>Am Samstag bieten alle Stände frisch zubereiteten Salzkuchen an (nur solange der Vorrat reicht). Dieser wird in zwei Backhäusern in Grunbach gebacken und ofenfrisch von designierten Fahrern zu den Ständen gebracht!</p>
            </b-col>
        </b-row>
        <b-row v-if="isFullSite">
            <b-col cols="12" lg="3">
                <b-card 
                    class="booth-card d-flex flex-column"
                    title="Stand 1"
                    img-src="../assets/images/booth1_home.jpg"
                    img-alt="Stand 1"
                    img-top
                    tag="article"
                >
                    <b-card-text>
                    Der erste Stand der Weinprobe bietet sonntags um 11 Uhr den alljährlichen Gottesdienst im Grünen.
                    </b-card-text>

                    <div slot="footer">
                        <b-button class="booth-button" to="Stand1" variant="primary">Weiter zu Stand 1</b-button>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" lg="3">
                <b-card 
                    class="booth-card"
                    title="Stand 2"
                    img-src="../assets/images/booth2_home.jpg"
                    img-alt="Stand 2"
                    img-top
                    tag="article"
                >
                    <b-card-text>
                    Die Spezialität des zweiten Standes sind Secco und Edelsüße Weine.
                    </b-card-text>

                    <div slot="footer">
                        <b-button class="booth-button" to="Stand2" variant="primary">Weiter zu Stand 2</b-button>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" lg="3">
                <b-card 
                    class="booth-card"
                    title="Stand 3"
                    img-src="../assets/images/booth3_home.jpg"
                    img-alt="Stand 3"
                    img-top
                    tag="article"
                >
                    <b-card-text>
                    Beim dritten Stand gibt es am Sonntag neben Grillwürsten auch wieder das beliebte Rebenhäcksel (Bruzzelfleisch).
                    </b-card-text>

                    <div slot="footer">
                        <b-button class="booth-button" to="Stand3" variant="primary">Weiter zu Stand 3</b-button>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" lg="3">
                <b-card 
                    class="booth-card"
                    title="Stand 4"
                    img-src="../assets/images/booth4_home.jpg"
                    img-alt="Stand 4"
                    img-top
                    tag="article"
                >
                    <b-card-text>
                    Beim vierten Stand der Weinprobe können verschiedene Sekte genossen werden.
                    </b-card-text>

                    <div slot="footer">
                        <b-button class="booth-button" to="Stand4" variant="primary">Weiter zu Stand 4</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'introduction',
    props: {
        year: {
            type: String
        },
        daySaturday: {
            type: String
        },
        daySunday: {
            type: String
        },
        weinprobenCounter: {
            type: String
        },
        isFullSite: {
            type: Boolean
        }
    },
  components: {
    
  }
}
</script>

<style scoped style="sass">
    .container {
        margin-top: 2em;
    }

    .highlights {
        margin-top: 1em;
    }

    .booth-card {
        height: 100%;
    }

    .booth-button {
        width: 100%;
    }
</style>
